

export default class ResultadoObtengaParametros{
    
    constructor(){
        this.ListaClaseDatos = [];
        this.ListaFechasEnvio = [];
        this.ListaEstado = [];
        this.ListaTiposSolicitud = [];
    }

    ListaClaseDatos : any;
    ListaFechasEnvio: any;
    ListaEstado: any;
    ListaTiposSolicitud: any;
}